import store from '@packages/store'
import Vue from 'vue'

export default {

    load(parentId) {
        return new Promise(
            (resolve) => {
                Vue.api.interactions.load(parentId).then(
                    (data) => {
                        store.commit('SET_INTERACTIONS', data)
                        resolve(data)
                    }
                )
            }
        )
    },

    options({ interactionId, advertisingId }) {
        return new Promise(
            (resolve) => {
                Vue.api.interactions.options.load({ interactionId, advertisingId }).then(
                    (data) => {
                        store.commit('SET_INTERACTION_OPTIONS', { interactionId, data })
                        resolve(data)
                    }
                )
            }
        )
    }

}
